/**
 * Helpers for API errors.
 *
 * The API returns RFC 9457 problem details (application/problem+json):
 * { type, title, status, detail, instance, code, request_id, errors? }.
 * Validation errors list field problems in errors: [{ field, message, code }].
 *
 * Older API builds sent Pydantic errors as [{ loc, msg }]. These helpers read
 * both shapes.
 */

/** Field problems as [{ field, message }]. field is null for the whole body. */
export const fieldErrors = (payload) => {
  const errors = payload?.errors;
  if (!Array.isArray(errors)) return [];
  return errors
    .filter((e) => e && typeof e === "object")
    .map((e) => {
      if ("message" in e) return { field: e.field ?? null, message: e.message };
      const loc = Array.isArray(e.loc) ? e.loc : e.loc != null ? [e.loc] : [];
      return {
        field: loc.length ? String(loc[loc.length - 1]) : null,
        message: e.msg,
      };
    })
    .filter((e) => e.message);
};

/** One message for a toast or banner. */
export const apiErrorMessage = (err, fallback) => {
  const payload = err?.payload;
  const errors = fieldErrors(payload);
  if (errors.length) {
    return errors
      .map((e) => (e.field ? `${e.field}: ${e.message}` : e.message))
      .join("\n");
  }
  return payload?.detail || payload?.title || err?.message || fallback;
};
